import app from '../../../scripts/app';
import template from './active-draft.jade';
import './active-draft.service';

/**
 * Переключатель активного черновика.
 * При включении отправляет объект ad на сервер с заданным интервалом.
 */
app.directive('cianAfActiveDraft', ['$interval', 'popupService', 'activeDraftService', 'deviceService', function($interval, popupService, activeDraftService, deviceService) {
  const autoSaveInterval = 10000;

  return {
    restrict: 'E',
    template,
    replace: true,
    scope: true,
    controllerAs: 'activeDraft',
    controller: ['$scope', function($scope) {
      const addFormCtrl = $scope.addFormCtrl;
      let activeDraftEnabled;
      let autoSavePromise;
      this.isLoading = true;

      this.isMobile = deviceService.isMobile;

      const saveDraft = () => {
        activeDraftService.saveDraft(addFormCtrl.ad, addFormCtrl.form);
      };

      // Включить/выключить автосохранение с заданным интервалом
      const enableAutoSave = (enable = true) => {
        if (enable) {
          saveDraft();
          autoSavePromise = $interval(saveDraft, autoSaveInterval);
        }
        else {
          $interval.cancel(autoSavePromise);
        }
      };

      this.hintText = `
      Активный черновик позволит вам вернуться к заполнению формы добавления объявления с того же момента,
      на котором вы остановились. Отключение света, Интернета или другой форс-мажор теперь не станет причиной потери информации.
      <br/><br/>
      Для тех агентств, которые публикуют объявления централизованно, рекомендуем отключать функцию,
      чтобы риэлторы не удаляли незаполненные формы при одновременном добавлении объектов на ЦИАН.
      `;

      this.openHintModal = () => {
        popupService.openPopup('hint', {
          text: this.hintText,
          title: 'Активный черновик',
          hideCloseButton: false,
        });
      };

      // Включить/выключить активный черновик
      const enableActiveDraft = (enable = true) => {
        activeDraftEnabled = enable;
        let req;

        if (enable) {
          req = activeDraftService.enableActiveDraft();
          req.then(enableAutoSave);
        }
        else {
          enableAutoSave(false);
          activeDraftService.deleteDraft(addFormCtrl.ad.objectGuid);
          req = activeDraftService.enableActiveDraft(false);
        }

        req.catch(error => {
          activeDraftEnabled = !enable;
          throw new Error(error);
        });
      };

      // Геттер/сеттер для activeDraftEnabled, спрашивает подтверждение перед изменением
      this.getterSetter = (enable) => {
        if (enable === undefined) return activeDraftEnabled;

        const options = {
          enable,
          onConfirm: () => enableActiveDraft(enable)
        };

        popupService.openPopup('activeDraft', { options });
      };

      activeDraftService.isActiveDraftEnabled()
        .then(enabled => {
          activeDraftEnabled = enabled;
          if (enabled) {
            enableAutoSave();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });

      $scope.$on('$destroy', () => {
        enableAutoSave(false);
      });
    }]
  };
}]);
